function ContabilidadReporteisn ($http, $filter) {
  this.get = function (idEmpresa, fechaInicial, fechaFinal) {
    return $http.get('/api/empresa/reporte/isn', {
      params: {
        id_empresa: idEmpresa,
        fecha_inicial: $filter('date')(fechaInicial, 'yyyy-MM-dd'),
        fecha_final: $filter('date')(fechaFinal, 'yyyy-MM-dd'),
      },
      download: true,
    })
  }
}

angular.module('contabilidad.reporteisn')
  .service('ContabilidadReporteisn', ContabilidadReporteisn)



// WEBPACK FOOTER //
// ./src/contabilidad/reporteisn/services/Reporteisn.js